import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { PATH_SIGN_IN } from '@jwp/ott-common/src/paths';
import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';
import type { Customer } from '@jwp/ott-common/types/account';

const hasAuthToken = (): boolean => {
  const accessToken = localStorage.getItem('access_token');
  if (accessToken) return true;

  try {
    const auth = JSON.parse(localStorage.getItem('jwapp.auth') || '');
    if (auth?.accessToken) return true;
  } catch {
    // invalid or missing JSON
  }

  const katonUserRaw = localStorage.getItem('katon_user');
  if (katonUserRaw) {
    try {
      const katonUser = JSON.parse(katonUserRaw);
      if (katonUser?.role === 'guest') return true;
    } catch {
      // invalid or missing JSON
      console.log('Invalid or missing JSON');
    }
  }

  return false;
};

const rehydrateUser = (): void => {
  const { user } = useAccountStore.getState();
  if (user) return;

  const raw = localStorage.getItem('katon_user');
  if (!raw) return;

  try {
    const stored: Customer = JSON.parse(raw);
    if (stored?.id) {
      useAccountStore.setState({ user: stored, loading: false });
    }
  } catch {
    localStorage.removeItem('katon_user');
  }
};

const ProtectedRoute: React.FC = () => {
  const location = useLocation();

  if (!hasAuthToken()) {
    return <Navigate to={PATH_SIGN_IN} state={{ from: location }} replace />;
  }

  rehydrateUser();

  return <Outlet />;
};

export default ProtectedRoute;
